import Cookies from 'universal-cookie';
import { Language } from '../types';
import en from 'assets/translations/locale-en';
import fi from 'assets/translations/locale-fi';
import config from 'config';

type CookieLanguage = '"fi"' | '"en"';

const cookies = new Cookies();
const translations = { en, fi };

export const cookieName = 'TRANSLATE_LANG_KEY';

const toCookie = (language: Language): CookieLanguage =>
    `"${language}"` as CookieLanguage;

export const setLanguage = (language: Language) => {
    currentLanguage = language;
    const path = `${config.baseName}/`;
    cookies.set(cookieName, toCookie(language), { path });
};

const fromCookie = (value?: CookieLanguage): Language | undefined =>
    value && (value.replace(/"/g, '') as Language);

export const getLanguage = (): Language =>
    fromCookie(cookies.get(cookieName) as CookieLanguage | undefined) || 'fi';

let currentLanguage: Language = getLanguage();

export const translate = (key: string) =>
    translations[currentLanguage][key] || key;

export default translate;
